/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SortOrder } from './SortOrder';
import {
    SortOrderFromJSON,
    SortOrderFromJSONTyped,
    SortOrderToJSON,
    SortOrderToJSONTyped,
} from './SortOrder';
import type { AccessRequestSearchOrderBy } from './AccessRequestSearchOrderBy';
import {
    AccessRequestSearchOrderByFromJSON,
    AccessRequestSearchOrderByFromJSONTyped,
    AccessRequestSearchOrderByToJSON,
    AccessRequestSearchOrderByToJSONTyped,
} from './AccessRequestSearchOrderBy';

/**
 * 
 * @export
 * @interface AccessRequestSearchOrderByPaginationQuery
 */
export interface AccessRequestSearchOrderByPaginationQuery {
    /**
     * 
     * @type {any}
     * @memberof AccessRequestSearchOrderByPaginationQuery
     */
    pageNumber?: any | null;
    /**
     * 
     * @type {any}
     * @memberof AccessRequestSearchOrderByPaginationQuery
     */
    pageSize?: any | null;
    /**
     * 
     * @type {SortOrder}
     * @memberof AccessRequestSearchOrderByPaginationQuery
     */
    sortOrder?: SortOrder;
    /**
     * 
     * @type {AccessRequestSearchOrderBy}
     * @memberof AccessRequestSearchOrderByPaginationQuery
     */
    orderField?: AccessRequestSearchOrderBy;
}



/**
 * Check if a given object implements the AccessRequestSearchOrderByPaginationQuery interface.
 */
export function instanceOfAccessRequestSearchOrderByPaginationQuery(value: object): value is AccessRequestSearchOrderByPaginationQuery {
    return true;
}

export function AccessRequestSearchOrderByPaginationQueryFromJSON(json: any): AccessRequestSearchOrderByPaginationQuery {
    return AccessRequestSearchOrderByPaginationQueryFromJSONTyped(json, false);
}

export function AccessRequestSearchOrderByPaginationQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestSearchOrderByPaginationQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'pageNumber': json['pageNumber'] === undefined ? undefined : json['pageNumber'] === null ? null : json['pageNumber'],
        'pageSize': json['pageSize'] === undefined ? undefined : json['pageSize'] === null ? null : json['pageSize'],
        'sortOrder': json['sortOrder'] == null ? undefined : SortOrderFromJSON(json['sortOrder']),
        'orderField': json['orderField'] == null ? undefined : AccessRequestSearchOrderByFromJSON(json['orderField']),
    };
}

export function AccessRequestSearchOrderByPaginationQueryToJSON(json: any): AccessRequestSearchOrderByPaginationQuery {
    return AccessRequestSearchOrderByPaginationQueryToJSONTyped(json, false);
}

export function AccessRequestSearchOrderByPaginationQueryToJSONTyped(value?: AccessRequestSearchOrderByPaginationQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
        'sortOrder': SortOrderToJSON(value['sortOrder']),
        'orderField': AccessRequestSearchOrderByToJSON(value['orderField']),
    };
}

